import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import flow from 'lodash/fp/flow'
import set from 'lodash/fp/set'

import {
    fetchTabDataFailure,
    fetchTabDataRequest,
    fetchTabDataSuccess,
    mountTabFailure,
    mountTabRequest,
    mountTabSuccess,
} from 'actions/ui/shared/tab'
import { LOADED_AT } from 'const/reducerKeys'
import { getCurrentTimestamp } from 'helpers/utils'

import { SharedState } from './state'

type TabStateSettableProp = 'mounting' | 'loading' | 'error' | typeof LOADED_AT

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function setTabStateProp(
    path: string[],
    prop: TabStateSettableProp,
    value: unknown
) {
    return set([...path, prop], value)
}

// Cases added to the shared/index createReducer; state is parent UI state
export const addTabCases = (
    builder: ActionReducerMapBuilder<SharedState>
): void => {
    builder
        // Mount
        .addCase(mountTabRequest, (state, action) =>
            setTabStateProp([...action.payload.path], 'mounting', false)(state)
        )
        .addCase(mountTabSuccess, (state, action) =>
            setTabStateProp([...action.payload.path], 'mounting', false)(state)
        )
        .addCase(mountTabFailure, (state, action) =>
            flow(
                setTabStateProp([...action.payload.path], 'mounting', false),
                setTabStateProp(
                    [...action.payload.path],
                    'error',
                    action.payload.data?.message
                )
            )(state)
        )
        // Fetch data
        .addCase(fetchTabDataRequest, (state, action) =>
            setTabStateProp([...action.payload.path], 'loading', false)(state)
        )
        .addCase(fetchTabDataSuccess, (state, action) =>
            flow(
                setTabStateProp([...action.payload.path], 'loading', false),
                setTabStateProp(
                    [...action.payload.path],
                    LOADED_AT,
                    getCurrentTimestamp()
                )
            )(state)
        )
        .addCase(fetchTabDataFailure, (state, action) =>
            flow(
                setTabStateProp([...action.payload.path], 'loading', false),
                setTabStateProp(
                    [...action.payload.path],
                    'error',
                    action.payload.data?.message
                )
            )(state)
        )
}
